import { ResponsiveBar } from "@nivo/bar";

const MyResponsiveBarByWRI = ({ data, dataGroupAttribute = "deviationsCount", indexByAttribute = "art" }) => {

    const transformedData = data?.map(item => ({
        [indexByAttribute]: item[indexByAttribute],
        ...item[dataGroupAttribute]
    })) || [];

    const keyNames = data?.length > 0
        ? [...new Set(
            data.flatMap(item =>
                Object.keys(item[dataGroupAttribute] || {})
            )
        )]
        : [];

    return (
        <ResponsiveBar
            data={transformedData}
            keys={keyNames}
            indexBy={indexByAttribute}
            padding={0.3}
            margin={{
                left: 50,
                bottom: 80,
                right: 50
            }}
            groupMode="grouped"
            colors={{ scheme: "pastel2" }}
            borderRadius={0}
            borderColor={{ from: "color", modifiers: [["darker", "1.2"]] }}
            axisTop={null}
            axisRight={null}
            axisBottom={{
                tickSize: 5,
                tickPadding: 5,
                tickRotation: 0,
                legendPosition: "middle",
                legendOffset: 36,
                format: value => value?.length > 20 ? value.substring(0, 20) + '...' : value,
            }}
            axisLeft={{
                tickSize: 5,
                tickPadding: 5,
                tickRotation: 0,
            }}
            legends={[
                {
                    dataFrom: "keys",
                    anchor: "bottom",
                    direction: "column",
                    justify: false,
                    translateX: 0,
                    translateY: 80,
                    itemsSpacing: 2,
                    itemWidth: 120,
                    itemHeight: 18,
                    itemDirection: "left-to-right",
                    itemOpacity: 0.85,
                    symbolSize: 14,
                    symbolSpacing: 6,
                    effects: [
                        {
                            on: "hover",
                            style: {
                                itemOpacity: 1,
                            },
                        },
                    ],
                },
            ]}
            enableLabel={false}
            labelSkipWidth={5}
            labelSkipHeight={8}
            labelTextColor={{ from: "color", modifiers: [["darker", 1.6]] }}
            animate
            motionStiffness={90}
            motionDamping={8}
        />
    );
};

export default MyResponsiveBarByWRI;
